import { render, staticRenderFns } from "./SaraSummaryView.vue?vue&type=template&id=16c51722&scoped=true&"
import script from "./SaraSummaryView.vue?vue&type=script&lang=ts&"
export * from "./SaraSummaryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c51722",
  null
  
)

export default component.exports